import React from "react"
import "../../assets/styles/nav/nav-footer-main.scss"

export default function FooterMainNav() {

  return (
    <ul className="footer-nav-main">
      <li>
        <a href="https://www.shatterproof.org/about-us">About Us</a>
      </li>
      <li>
        <a href="https://www.shatterproof.org/learn/addiction-basics/addiction-in-america">Addition in America</a>
      </li>
      <li>
        <a href="https://www.shatterproof.org/our-work">Our Work</a>
      </li>
      <li>
        <a href="https://www.shatterproof.org/learn">Learn</a>
      </li>
      <li>
        <a href="https://www.shatterproof.org/find-help">Find Help</a>
      </li>
      <li>
        <a href="https://www.shatterproof.org/get-involved">Get Involved</a>
      </li>
      <li className="donate">
        <a href="https://bit.ly/3FSCCxo">Donate</a>
      </li>
    </ul>
  )
}
